import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashikcabservice() {



    const cardData = {

keyword: "Pune to Nashik Cab Service",

headingDescription:
    "Rising Cab Service offers reliable and affordable Pune to Nashik Cab Service for families, pilgrims, business travelers, and tourists. We provide comfortable one-way and round-trip taxi services with Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs. Our service includes doorstep pickup, 24/7 booking support, transparent pricing, and well-maintained vehicles to ensure a safe and pleasant journey. Whether you're traveling for pilgrimage, sightseeing, or business, Rising Cab Service makes your Pune to Nashik trip comfortable and hassle-free.",

topPlaces: [
    {
        title: "Trimbakeshwar Jyotirlinga",
        description:
            "Trimbakeshwar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva and the most famous spiritual destination near Nashik. The ancient temple is known for its unique architecture and deep religious significance."
    },
    {
        title: "Panchvati",
        description:
            "Panchvati is a sacred area associated with the Ramayana where Lord Rama, Sita, and Lakshmana spent part of their exile. It is home to Kalaram Temple, Sita Gufa, and holy Godavari ghats."
    },
    {
        title: "Sula Vineyards",
        description:
            "Sula Vineyards is India's leading wine destination, offering vineyard tours, wine tasting experiences, luxury stays, and beautiful landscapes for visitors."
    },
    {
        title: "Pandavleni Caves",
        description:
            "Pandavleni Caves are ancient Buddhist rock-cut caves dating back over two thousand years. The caves feature impressive carvings and provide scenic views of Nashik city."
    },
    {
        title: "Anjaneri Hills",
        description:
            "Anjaneri Hills are believed to be the birthplace of Lord Hanuman and are popular for trekking, spiritual visits, and enjoying the natural beauty of the Sahyadri ranges."
    },
    {
        title: "Muktidham Temple",
        description:
            "Muktidham Temple is a beautiful marble temple complex featuring replicas of the twelve Jyotirlingas and several Hindu deities, making it a peaceful pilgrimage destination."
    },
    {
        title: "Godavari River Ghats",
        description:
            "The sacred Godavari Ghats are important religious sites where devotees perform rituals and holy baths. The area is especially significant during the Kumbh Mela festival."
    },
    {
        title: "Saptashrungi Devi Temple",
        description:
            "Saptashrungi Devi Temple is one of Maharashtra's revered Shakti Peethas situated amidst scenic hills. Thousands of devotees visit the temple throughout the year."
    },
    {
        title: "Coin Museum",
        description:
            "The Coin Museum in Nashik showcases a remarkable collection of ancient and modern Indian coins, offering visitors an interesting insight into the country's monetary history."
    },
    {
        title: "Harihar Fort",
        description:
            "Harihar Fort is a famous trekking destination near Nashik known for its steep rock-cut staircase and breathtaking mountain views, attracting adventure seekers and nature lovers."
    }
],



services: [
    {
        name: "Pune to Nashik Cab",
        description:
            "Rising Cab Service offers Pune to Nashik Cab services for comfortable, safe, and affordable intercity travel. Whether you are travelling for business, family visits, temple darshan, wine tourism, corporate meetings, or holiday trips, we provide well-maintained AC vehicles and experienced drivers for a hassle-free journey. Customers can choose from hatchbacks, sedans, SUVs, Ertiga, Innova, and Innova Crysta according to their travel requirements. We provide one-way and round-trip options, transparent pricing, door-to-door pickup and drop, and 24x7 customer support for a smooth travel experience between Pune and Nashik."
    },
    {
        name: "Pune to Nashik Taxi",
        description:
            "Book Pune to Nashik Taxi with Rising Cab Service for reliable and comfortable transportation. Our service includes professional chauffeurs, clean vehicles, affordable fares, and flexible travel schedules for business and leisure travellers."
    },
    {
        name: "Cab from Pune to Nashik",
        description:
            "Rising Cab Service provides Cab from Pune to Nashik with convenient pickup and drop services, one-way and round-trip options, and comfortable AC vehicles for safe highway travel."
    },
    {
        name: "Taxi from Pune to Nashik",
        description:
            "Our Taxi from Pune to Nashik service offers dependable transportation for families, tourists, corporate clients, and pilgrims with experienced drivers and transparent pricing."
    },
    {
        name: "Pune to Nashik Cab Service",
        description:
            "Rising Cab Service provides Pune to Nashik Cab Service with flexible travel packages, professional drivers, and comfortable vehicles suitable for all travel needs."
    },
    {
        name: "Pune to Nashik Taxi Fare",
        description:
            "Get affordable Pune to Nashik Taxi Fare with Rising Cab Service. We offer competitive pricing, clear billing, and economical travel options without hidden charges."
    },
    {
        name: "Pune to Nashik One Way Cab",
        description:
            "Book Pune to Nashik One Way Cab for economical single-direction travel with affordable pricing and professional drivers."
    },
    {
        name: "Pune to Nashik Round Trip Taxi",
        description:
            "Rising Cab Service offers Pune to Nashik Round Trip Taxi with flexible return schedules and waiting options for business and family travel."
    },
    {
        name: "Pune to Nashik Cab Booking",
        description:
            "Our Pune to Nashik Cab Booking service provides instant and advance reservations with multiple vehicle choices and quick confirmation."
    },
    {
        name: "Cheap Pune to Nashik Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Nashik Cab with budget-friendly fares while ensuring safe and comfortable travel."
    },
    {
        name: "Best Pune to Nashik Taxi",
        description:
            "Choose the Best Pune to Nashik Taxi with Rising Cab Service for premium travel comfort, professional chauffeurs, and dependable service."
    },
    {
        name: "Sedan Pune to Nashik Cab",
        description:
            "Our Sedan Pune to Nashik Cab service provides spacious and comfortable vehicles for individuals, couples, and small families."
    },
    {
        name: "SUV Pune to Nashik Taxi",
        description:
            "Book SUV Pune to Nashik Taxi for larger groups and extra luggage with comfortable seating and smooth travel."
    },
    {
        name: "Innova Pune to Nashik Cab",
        description:
            "Rising Cab Service offers Innova Pune to Nashik Cab for family tours, corporate travel, and group journeys with premium comfort."
    },
    {
        name: "Pune to Nashik Innova Crysta Cab",
        description:
            "Our Pune to Nashik Innova Crysta Cab service provides luxury travel with spacious seating, premium interiors, and experienced chauffeurs."
    },
    {
        name: "Pune to Nashik Cabs",
        description:
            "Rising Cab Service provides Pune to Nashik Cabs with one-way, round-trip, and customized travel packages for business and leisure travel."
    },
    {
        name: "Pune to Nashik Cab Service",
        description:
            "Book Pune to Nashik Cab Service with Rising Cab Service for reliable transportation, affordable fares, and comfortable vehicles."
    },
    {
        name: "Pune to Nashik Taxi Service",
        description:
            "Our Pune to Nashik Taxi Service offers safe and convenient travel with professional drivers and flexible booking options."
    },
    {
        name: "Pune to Nashik Cab Booking",
        description:
            "Rising Cab Service provides Pune to Nashik Cab Booking with instant confirmation and 24x7 customer assistance."
    },
    {
        name: "Best Pune to Nashik Cab",
        description:
            "Choose the Best Pune to Nashik Cab with Rising Cab Service for quality vehicles, experienced drivers, and a comfortable travel experience."
    },
    {
        name: "Cheap Pune to Nashik Taxi",
        description:
            "Our Cheap Pune to Nashik Taxi service offers economical travel solutions with transparent pricing and comfortable vehicles."
    },
    {
        name: "24x7 Pune to Nashik Cab Service",
        description:
            "Book 24x7 Pune to Nashik Cab Service with Rising Cab Service for reliable transportation any time of the day or night."
    },
    {
        name: "One Way Pune to Nashik Cab",
        description:
            "Rising Cab Service offers One Way Pune to Nashik Cab for affordable and convenient single-trip travel."
    },
    {
        name: "Round Trip Pune to Nashik Taxi",
        description:
            "Our Round Trip Pune to Nashik Taxi service provides flexible travel plans for family vacations, business meetings, and temple visits."
    },
    {
        name: "Outstation Cab Pune to Nashik",
        description:
            "Book Outstation Cab Pune to Nashik with Rising Cab Service for safe, comfortable, and affordable long-distance travel."
    },
    {
        name: "Innova Crysta Cab Pune to Nashik",
        description:
            "Rising Cab Service offers Innova Crysta Cab Pune to Nashik with luxury seating, spacious interiors, and premium travel comfort."
    },
    {
        name: "Pune to Nashik Crysta Taxi",
        description:
            "Our Pune to Nashik Crysta Taxi service provides premium transportation for family tours, business travel, and VIP journeys."
    },
    {
        name: "Luxury Innova Cab Pune Nashik",
        description:
            "Book Luxury Innova Cab Pune Nashik for a premium travel experience with professional chauffeurs and comfortable seating."
    },
    {
        name: "Pune Nashik Innova Cab Booking",
        description:
            "Rising Cab Service provides Pune Nashik Innova Cab Booking with easy reservations and premium vehicle options for comfortable intercity travel."
    },
    {
        name: "AC Innova Crysta Pune to Nashik",
        description:
            "Our AC Innova Crysta Pune to Nashik service offers luxurious air-conditioned travel with spacious cabins and professional drivers for a smooth journey."
    }
],

tableData: [
    ["Pune to Nashik Cab", "Pune to Nashik Taxi"],
    ["Cab from Pune to Nashik", "Taxi from Pune to Nashik"],
    ["Pune to Nashik Cab Service", "Pune to Nashik Taxi Fare"],
    ["Pune to Nashik One Way Cab", "Pune to Nashik Round Trip Taxi"],
    ["Pune to Nashik Cab Booking", "Cheap Pune to Nashik Cab"],
    ["Best Pune to Nashik Taxi", "Sedan Pune to Nashik Cab"],
    ["SUV Pune to Nashik Taxi", "Innova Pune to Nashik Cab"],
    ["Pune to Nashik Innova Crysta Cab", "Pune to Nashik Cabs"],
    ["Pune to Nashik Cab Service", "Pune to Nashik Taxi Service"],
    ["Pune to Nashik Cab Booking", "Best Pune to Nashik Cab"],
    ["Cheap Pune to Nashik Taxi", "24x7 Pune to Nashik Cab Service"],
    ["One Way Pune to Nashik Cab", "Round Trip Pune to Nashik Taxi"],
    ["Outstation Cab Pune to Nashik", "Innova Crysta Cab Pune to Nashik"],
    ["Pune to Nashik Crysta Taxi", "Luxury Innova Cab Pune Nashik"],
    ["Pune Nashik Innova Cab Booking", "AC Innova Crysta Pune to Nashik"]
],




whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Nashik Cab Travel",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Nashik cab services for business travelers, pilgrims, families, tourists, and groups looking for a smooth intercity travel experience."
    },
    {
        WhyChooseheading: "Perfect for Religious and Leisure Trips",
        WhyChoosedescription: "Travel conveniently to Trimbakeshwar Temple, Panchavati, Sula Vineyards, Muktidham Temple, and other popular attractions in and around Nashik."
    },
    {
        WhyChooseheading: "Multiple Vehicle Options Available",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to travel preferences and group size."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Packages",
        WhyChoosedescription: "Whether you need a one-way transfer, same-day return trip, weekend tour, or customized itinerary, we offer flexible travel options."
    },
    {
        WhyChooseheading: "Convenient Pickup Across Pune",
        WhyChoosedescription: "Pickup facilities are available from Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and all major Pune locations."
    },
    {
        WhyChooseheading: "Safe Highway Travel Experience",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune-Nashik routes and ensure a safe, comfortable, and hassle-free journey."
    },
    {
        WhyChooseheading: "Suitable for Family and Corporate Travel",
        WhyChoosedescription: "The service is ideal for family vacations, pilgrimage tours, business meetings, corporate visits, and weekend getaways."
    },
    {
        WhyChooseheading: "Travel Plans Tailored to Your Schedule",
        WhyChoosedescription: "Rising Cab Service allows travelers to plan departures, sightseeing stops, and return schedules according to their convenience."
    }
]
};

const faqData = [
    {
        question: "What are the popular places covered during a Pune to Nashik trip?",
        answer: "Travelers often visit Trimbakeshwar Temple, Panchavati, Kalaram Temple, Sula Vineyards, Muktidham Temple, and Coin Museum."
    },
    {
        question: "Can pilgrims include Trimbakeshwar Darshan in the journey?",
        answer: "Yes, customized travel plans can include Trimbakeshwar Temple and other nearby religious destinations."
    },
    {
        question: "Which vehicle is best suited for a family trip to Nashik?",
        answer: "Many families prefer Ertiga and Innova Crysta for their spacious seating and comfortable travel experience."
    },
    {
        question: "Are one-way cab bookings available from Pune to Nashik?",
        answer: "Yes, customers can choose one-way travel as well as round-trip packages."
    },
    {
        question: "Can groups hire Tempo Travellers for Nashik tours?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for group tours, corporate outings, and pilgrimage travel."
    },
    {
        question: "Do business travelers use Pune to Nashik cab services?",
        answer: "Yes, many professionals travel between Pune and Nashik for industrial visits, meetings, and corporate activities."
    },
    {
        question: "Can sightseeing locations be added to the itinerary?",
        answer: "Yes, travel routes can be customized to include tourist attractions, temples, and vineyards."
    },
    {
        question: "Is same-day return travel possible for Nashik?",
        answer: "Yes, many travelers choose same-day return trips depending on their schedule and sightseeing plans."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, passengers can start their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "How can travelers reserve a Pune to Nashik Cab Service?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Milind Chavan",
        feedback:
            "A recent visit to Nashik and Trimbakeshwar was planned perfectly. The driver was knowledgeable about the route, and the entire journey remained comfortable and enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Reshma Korde",
        feedback:
            "Our group traveled to Nashik for a family function, and the experience was excellent. The vehicle was spacious, the travel arrangements were smooth, and everything went according to schedule.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Nashik Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-nashik-cab-service.jpg",
"description": "Book Pune to Nashik Cab Service with Rising Cab Service for safe, comfortable, and affordable outstation travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova Crysta for family and group trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-nashik-cab-service"
}
};






    return (
        <div>
<Helmet>
  <title>Pune to Nashik Cab Service | One Way & Round Trip Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Nashik Cab Service for outstation travel, temple visits, and family trips. Get affordable one-way and round-trip taxi service with sedan, SUV, and Innova Crysta options."
/>

<meta
 name="keywords"
 content="Pune to nashik cab, pune to nashik taxi, cab from pune to nashik, taxi from pune to nashik, pune to nashik cab service, pune to nashik taxi fare, pune to nashik one way cab, pune to nashik round trip taxi, pune to nashik cab booking, cheap pune to nashik cab, best pune to nashik taxi, sedan pune to nashik cab, suv pune to nashik taxi, innova pune to nashik cab, pune to nashik innova crysta cab, Pune to Nashik Cabs, Pune to Nashik Cab Service, Pune to Nashik Taxi Service, Pune to Nashik Cab Booking, Best Pune to Nashik Cab, Cheap Pune to Nashik Taxi, 24x7 Pune to Nashik Cab Service, One Way Pune to Nashik Cab, Round Trip Pune to Nashik Taxi, Outstation Cab Pune to Nashik"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetonashikcabservice;